import { useRef, useState, useEffect } from "react";

import {
  Card,
  Paper,
  Box,
  IconButton,
  Typography,
  Grid,
  Divider
} from "@mui/material";

import { useReactToPrint } from "react-to-print";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useLocation } from "react-router-dom";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../AuthProvider";

// After all necessary imports...

const TransferCertificate2 = () => {
  const navigate = useNavigate();
  const componentRef = useRef();
  const { oId ,board,pId} = useAuth();
  const { tcId } = useParams();

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const location = useLocation();

  const studentData = location.state?.studentData;

  const [studentDetails, setStudentDetails] = useState(null); 


   useEffect(() => {
      if (!tcId || !oId) {
        console.warn("TCID or OID is null or undefined.");
        return;
      }
  
      const fetchData = async () => {
        try {
          const response = await fetch(`${baseUrl}/api/studentTransfer/getAllByTcId/${tcId}/${oId}/${pId}`);
  
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
  
          const data = await response.json();
  
          // Check if data is an array and has at least one element
          if (Array.isArray(data) && data.length > 0) {
            setStudentDetails(data[0]); // Store the first object from array
          } else {
            console.warn("Received empty or unexpected data format.");
            setStudentDetails(null);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
  
      fetchData();
    }, [tcId, oId]);


  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Transfer Certificate",
  });

  const [companyInfo, setCompanyInfo] = useState({});
  useEffect(() => {
    const fetchCompanyInfo = async () => {
      try {
        const response = await fetch(`${baseUrl}/api/v1/organisation/${oId}`);
        const data = await response.json();
        setCompanyInfo(data);
      } catch (error) {
        console.error("Error fetching organization data:", error);
      }
    };
    fetchCompanyInfo();
  }, []);

  return (
    <Card sx={{ borderRadius: 2, m: "40px auto", p: 2 }}>
      {/* Back and Print Buttons */}
      <Box className="print-hide" sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
      <Box display="flex" alignItems="center">
                    <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
                      <KeyboardBackspaceIcon fontSize="medium" />
                    </IconButton>
                    <Typography variant="h4" component="h3" sx={{ fontWeight: "bold", marginLeft: 0 }}>
                      TRANSFER CERTIFICATE
                    </Typography>
                  </Box>
        <button onClick={handlePrint} style={{
          background: "#3C3972", color: "white", padding: "8px 16px",
          borderRadius: "5px", border: "none", fontWeight: "bold"
        }}>
          Print
        </button>
      </Box>

      {/* Certificate */}
      <Paper
        ref={componentRef}
        elevation={2}
        sx={{
          width: "210mm",
       
          mx: "auto",
          p: "10px 20px 20px 20px",
          border: "2px solid #000",
          backgroundColor: "white",
          color: "#000",
          fontSize: "14px",
          lineHeight: 1.8,
          '@media print': {
            boxShadow: "none",
            border: "2px solid #000",
            margin: 0,
            padding: "30px 40px",
          }
        }}
      >
        {/* Header Section */}
        <Box sx={{ textAlign: "center" }}>
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      mb: 1,
    }}
  >
    {/* Left: Logo */}
    <Box sx={{ width: "80px", display: "flex", justifyContent: "flex-start" }}>
      <img
              src={`data:image/jpeg;base64,${companyInfo.schoolLogo}`}
              alt="Logo"
              style={{
                width: "120px",         // Set a single value
                height: "120px",        // Match the width exactly
                borderRadius: "50%",    // Ensures circle
                objectFit: "cover",     // Ensures image fills without distortion
              }}
            />
    </Box>

    {/* Center: School Details */}
    <Box sx={{ flex: 1, textAlign: "center" }}>
      <Typography variant="h6" sx={{ fontWeight: "bold", textTransform: "uppercase" }}>
          {companyInfo.schoolName}
      </Typography>
      <Typography variant="body2">Kingdom of Bahrain</Typography>
      <Typography variant="caption">
        {companyInfo.schoolAddress} - {companyInfo.pincode}
      </Typography>
      <br />
      <Typography variant="caption">
       Phone: {companyInfo.primaryContact} | Email: {companyInfo.schoolEmailId}
      </Typography>
      {/* <Typography variant="caption">Estb. 1950</Typography> */}
    </Box>

    {/* Right: Empty for balancing */}
    <Box sx={{ width: "80px" }}></Box>
  </Box>

  {/* Title and TC No. */}
  <Box sx={{ position: "relative", mt: 2, mb: 1 }}>
    <Typography
      variant="h6"
      sx={{
        textDecoration: "underline",
        fontWeight: "bold",
        textAlign: "center",
      }}
    >
      Transfer Certificate
    </Typography>
    <Typography
      variant="body2"
      sx={{
        fontWeight: "bold",
        position: "absolute",
        top: 0,
        right: 0,
      }}
    >
      TC No : 2017-2018/14473
    </Typography>
  </Box>
</Box>


<Divider sx={{ my: 1, borderColor: "#000" }} />
        {/* Body Section */}
        <Box sx={{ mt: 2 }}>
  {[
    ["1. Name of the Student", `${studentDetails?.surName || ""} ${studentDetails?.firstName || ""} ${studentDetails?.lastName || ""}`],
    ["2. General Register Number", "47022"],
    ["3. G.P.R Number", "021219630"],
    ["4. Sex", "MALE"],
    ["5. Name of Father/Legal Guardian", `${studentDetails?.fathersFirstName || ""} ${studentDetails?.fathersLastName || ""}` ],
    ["6. Nationality", studentDetails?.nationality || "N/A" ],
    ["7. Date of Birth according to admission register",studentDetails?.dob || "N/A" ],
   
    ["8. Date of Admission",  studentDetails?.admissionDate || "N/A"],
    ["9. Admitted to Class", "VII (SEVENTH)"],
    ["10. Class Attending at the time of leaving", "IX B"],
    ["11. Date of Leaving the School", "28 Mar 2018"],
    ["12. Class at the time of issue", "IX B (NINTH)"],
    ["13. Reason of Leaving", studentDetails?.reasonForTransfer || "N/A"],
    ["14. Whether all dues paid to the School", "YES"],
    ["15. School fees paid up to", "MAR 2018"],
    ["16. General conduct", "GOOD"],
    
    ["18. Whether Qualified for Promotion", "YES"],
    ["19. C.B.S.E Roll No./Pre-registration", "D/19/77251/10057"],
    ["20. Result", "PASSED AND PROMOTED TO STD X (TENTH)"],
    ["21. Date of issue of TC", new Date().toLocaleDateString()],
  ].map(([label, value], index) => (
    <Box key={index} sx={{ display: "flex", mb: 0.5 }}>
      <Box sx={{ width: "45%", textAlign: "lift", pr: 1 }}>{label}</Box>
      <Box sx={{ width: "10px", textAlign: "center" }}>:</Box>
      <Box sx={{ flex: 1, pl: 1 }}>{value}</Box>
    </Box>
  ))}
</Box>


        {/* Footer Section */}
        
        <Typography variant="body2" sx={{ mt:5, textAlign: "center" }}>
          Certified that the above information is as per the records of the school. No changes can be made except by the Authority issuing the Certificate.
        </Typography>

        <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ textAlign: "center" }}>
            <Typography>Verified by:</Typography>
            <Typography fontWeight="bold">Academic Coordinator</Typography>
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <Typography fontWeight="bold">Principal</Typography>
          </Box>
        </Box>

<Divider sx={{ my: 1, borderColor: "#000" }} />
        <Box sx={{ mt: 1, textAlign: "center", fontSize: "12px" }}>
          <Typography>P.O. Box 558, Manama, Tel. 00973 17884616, Fax: 00973 681420, Email: indiansch@batelco.com.bh</Typography>
          <Typography>Website: www.indianschool.bh</Typography>
        </Box>
      </Paper>
    </Card>
  );
};

export default TransferCertificate2;